import React, { Component } from 'react'
import { Link } from 'react-router-dom'

import styles from './styles.scss'

/** Components */
import IconComponent from '@/components/commons/IconComponent'
import Button from '@/components/Button'

class Welcome extends Component {
  render () {
    return (
      <section className={styles['wrapper-welcome']}>
        <div className={styles['wrapper-welcome__content']}>
          <h1>Welcome to Magazine Creator</h1>
          <p>Nunc nonummy metus. Vestibulum ante ipsum primis in faucibus orci luctus.</p>
          <Link to='/first-magazine'>
            <Button
              size="large"
            >
            Come On!
              <IconComponent icon="arrow-right" />
            </Button>
          </Link>

          <div className={styles['wrapper-welcome__content-illustration']} />
        </div>
      </section>
    )
  }
}

export default Welcome



// WEBPACK FOOTER //
// ./src/pages/Welcome/index.js